import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.target = document.querySelector(this.el.getAttribute('data-highlight-target'))

    if (!this.target)
      return

    setTimeout(() => {
      let elts = this.target.querySelectorAll('.char')

      if (elts.length === 0) {
        elts = this.target.querySelectorAll('.word')
      }

      if (elts.length !== 0) {
        this.tl = gsap.timeline({ paused: true })
        this.tl.fromTo(
          elts,
          { opacity: 0.2 },
          {
            opacity: 1,
            duration: 0.4,
            ease: 'none',
            stagger: 0.1
          }
        )
      }
    }, 500)

    this.onHighlightProgress = this.onHighlightProgress.bind(this)

    window.addEventListener('highlightProgress', this.onHighlightProgress)
  }

  onHighlightProgress(e) {
    if (this.target && this.tl) {
      this.tl.progress(e.detail.progress)
    }
  }

  init() {
  }

  destroy() {
    window.removeEventListener('highlightProgress', this.onHighlightProgress)
  }
}
